



















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { LaborOpCode } from '@/models/admin/laboropcode';
import { Utils } from '@/helper/utils';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { laborOpCodeService } from '@/shared';
import { getLaboropCodeHeaders } from '@/views/admin/laboropcode/laboropcode';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Stores: () => import('@/components/common/store.select.vue'),
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class LaborOpCodeListPage extends Base {
  public pagedLaborOpCode: any[] = [];
  public storeId: number = 0;
  public pagination = new PaginationModel('operationCode', true);
  public loading: boolean = false;
  public actions: any[] = [];
  public headers: VHeaders[] = getLaboropCodeHeaders(this);

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('laborOpCode.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteLaborOpCode();
    },
  };
  public laborOpCodeIdToDelete: number = 0;

  public searched: boolean = false;
  public deleted: boolean = false;

  public flags = {
    loading: false,
  };

  public created() {
    this.storeId = Number(this.$route.params.storeId)
      ? Number(this.$route.params.storeId)
      : Number(this.userSession.storeId);
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addLaborOpCode') {
      if (!this.storeId) {
        this.showAlert(false, 'No Store Selected');
        this.resetMethodName(methodName);
        return;
      }
      this.laborOpCodeAdd();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('laborOpCode.btnAddLaborOpCode'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('laborOpCode.btnAddLaborOpCode'),
      click: 'addLaborOpCode',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'laborOpCode');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (!this.checkUserRole(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
      this.getLaborOpCodes();
    }

    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: this.$t(
          'laborOpCode.laborOpCodeGridHeaders.gridAction.edit'
        ) as string,
        action: (model: LaborOpCode) => {
          return {
            name: 'admin.laboropcode.edit',
            params: {
              id: model.id,
              storeId: this.storeId,
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'laborOpCode.laborOpCodeGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        action: (model: LaborOpCode) => {
          this.confirmDelete(model.id);
        },
      },
    ];
    this.pagination.sortBy = 'operationCode';
    this.pagination.descending = false;
  }

  public async getLaborOpCodes(): Promise<void> {
    try {
      this.flags.loading = true;
      const resp = await laborOpCodeService.getLaborOpCode(this.storeId);
      this.pagedLaborOpCode = resp.results;
      this.pagination.totalItems = this.pagedLaborOpCode.length;
    } finally {
      this.flags.loading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public confirmDelete(id: number): void {
    this.deleteDialog.model = true;
    this.laborOpCodeIdToDelete = id;
  }

  public async deleteLaborOpCode(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await laborOpCodeService.deleteLaborOpCodeById(
        this.laborOpCodeIdToDelete,
        this.storeId
      );
      this.deleted = true;
      this.showAlert(true, this.$t('laborOpCode.alertDeleteLaborOpCode'));
      this.getLaborOpCodes();
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.model = false;
    }
  }

  public updateStore(storeId: number): void {
    this.storeId = storeId;
    this.getLaborOpCodes();
  }
  public checkUserRole(routeRoles: string[]): boolean {
    return this.isAuthorizedToAccess(routeRoles);
  }
  public laborOpCodeAdd(): void {
    this.$router.push({
      name: 'admin.laboropcode.add',
      params: { storeId: this.storeId.toString() },
    });
  }
}
